import { UrlEnvironmentType } from '@/typings/url';
import { useAdminDevStagingProdEnvs } from './admin/environments';

/**
 * Use `useDbtCloud()` instead to get current data.
 *
 * This method is used to either retrieve projectId from environmentId
 * or retrieve environmentId from projectId.
 */
export const useResolveProjectAndEnvironmentId = ({
  accountId,
  projectId,
  environmentType,
}: {
  accountId: number | undefined;
  projectId: number | undefined;
  environmentType: UrlEnvironmentType | undefined;
}) => {
  const defaultEnvironments = useAdminDevStagingProdEnvs({
    accountId,
    projectId,
  });
  if (!environmentType) {
    return null;
  }
  const env = defaultEnvironments.data?.[environmentType];
  return {
    ...defaultEnvironments,
    data: {
      projectId: env?.project_id,
      environmentId: env?.id,
      accountId,
      enableModelQueryHistory: env?.enable_model_query_history ?? false,
    },
  };
};
